module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_library.js
// module id = dG4y
// module chunks = 1